import React, { type PropsWithChildren } from "react";

import { ButtonCell } from "../../../ButtonCell";
import { createDisplayNameForButtonCellSchevronElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellSchevronElement } from "../../utils/getTestId";

const BUTTON_CELL_SCHEVRON_LEFT_ADDON_TEST_ID =
    createTestIdForButtonCellSchevronElement("left-addon");

export const ButtonCellSchevronLeftAddon = ({
    children,
}: PropsWithChildren) => {
    return (
        <ButtonCell.LeftAddon
            data-tsid={BUTTON_CELL_SCHEVRON_LEFT_ADDON_TEST_ID}
        >
            {children}
        </ButtonCell.LeftAddon>
    );
};

ButtonCellSchevronLeftAddon.displayName =
    createDisplayNameForButtonCellSchevronElement("LeftAddon");
export default ButtonCellSchevronLeftAddon;
